import { fetcher } from "@certn/api";
import { showToast } from "@certn/cascadia";
import { useContext, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { OrderContext } from "../../pages/order/OrderContext";
interface GeneratedMessage {
  message: string;
  value?: string;
}
interface UseAIMessageGeneratorProps {
  onMessageGenerated?: (message: string) => void;
  value?: string;
}

export function useAIMessageGenerator({
  onMessageGenerated,
  value,
}: UseAIMessageGeneratorProps = {}) {
  const { t } = useTranslation();
  const { order } = useContext(OrderContext);
  const [message, setMessage] = useState(value);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (value !== undefined) {
      setMessage(value);
    }
  }, [value]);

  const checks =
    order.checks.length > 0 ? order.checks : order?.packageData?.checks;

  const generateMessage = async () => {
    try {
      setIsSubmitting(true);
      const response: GeneratedMessage = await fetcher.submit(
        "/api/internal/client-portal/order/generate-additional-message/",
        {
          checks: checks?.map((check) => check.name),
          existing_message: message,
          group_id: order.group,
        }
      );
      setMessage(response.message);
      onMessageGenerated?.(response.message);
    } catch (error) {
      console.error("Error generating AI message:", error);
      showToast(t("Something went wrong, try again"), {
        type: "error",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleMessageChange = (newMessage: string) => {
    setMessage(newMessage);
    onMessageGenerated?.(newMessage);
  };

  return {
    message,
    isSubmitting,
    setMessage: handleMessageChange,
    generateMessage,
  };
}
